import {calculateRelatedScores, type Progress, type ProgressAggregates} from '@cp/model';
import {useCallback} from 'react';
import listProgressDoc from '../../api/progress/listProgressDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';
import handlePermissionDeniedListError from '../helper/error/handlePermissionDeniedListError';

interface UseListUserProgressOptions {
  skip?: boolean;
}

export default function useListUserProgress(options?: UseListUserProgressOptions) {
  const skip = options?.skip ?? false;
  const shouldFetch = !skip;

  const load = useCallback((): Promise<Progress[]> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) {
      return Promise.resolve([]);
    }
    return listProgressDoc(uid);
  }, []);

  const {data, loading, error, refetch} = useFunctionRun(load, {
    skip: !shouldFetch,
  });

  const handled = handlePermissionDeniedListError(data, error);

  const progressList: (Progress & ProgressAggregates)[] = handled.items.map((p) => ({
    ...p,
    ...calculateRelatedScores(p),
  }));

  return {
    progressList,
    loading,
    error: handled.error ?? null,
    refetch,
  };
}
